module.exports = __webpack_public_path__ + "static/media/h5_june.210afafe.png";